import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchNotifications } from 'notifications/store/NotificationSlice';

import { createSnack } from 'snackbar/snackbarSlice';
import { resetCreatePto } from 'feature/inventory-management/product-transfer-order/store/createOrder';
import {
  fetchPtoDetails,
  getPtoDetails,
  getPtoDetailsPending,
} from 'feature/inventory-management/product-transfer-order/store/orderDetails';
import {
  resetCurrentPtoDialog,
  setCurrentPtoDialogueOpen,
} from 'feature/inventory-management/product-transfer-order/store/orderDrawer';
import { fetchOpenPTOs } from 'feature/inventory-management/product-transfer-order/store/openOrder';
import { fetchSearchPTOs } from 'feature/inventory-management/product-transfer-order/store/searchOrder';
import ConfirmationDialog from './ConfirmationDialog';

const mapState = state => ({
  currentPtoDialogueOpen: state.pto.ptoDrawer.currentPtoDialogueOpen,
  ptoDetails: getPtoDetails(state),
  ptoDetailsPending: getPtoDetailsPending(state),
  ptoNumber: state.pto.ptoDrawer.ptoNumber,
});

const mapDispatch = dispatch => ({
  dispatch,
  ...bindActionCreators(
    {
      createSnack,
      fetchNotifications,
      fetchOpenPTOs,
      fetchPtoDetails,
      fetchSearchPTOs,
      resetCreatePto,
      resetCurrentPtoDialog,
      setCurrentPtoDialogueOpen,
    },
    dispatch
  ),
});

export default connect(mapState, mapDispatch)(ConfirmationDialog);
